import _ from 'lodash';
import { Parser } from 'formulex';

import { t } from 'i18next';
import { FORMULA_REQUIRED_CONFIG_PARAMS, FORMULA_TYPES } from '../../configs/formula';
import { getImmutableField } from './getImmutableField';
import { getValidateError } from './getValidateError';

export const validateFormula = (formula, field, fields, varAttr = 'id') => {
  if (!formula) {
    return [];
  }

  const errors = [];
  let preparedFields = fields.toJS ? fields.toJS() : _.cloneDeep(fields);
  // В случае аттрибута id, в формуле может оказаться переменная по ключу newId, поэтому добавляем филды по ключу newId
  if (varAttr === 'id') {
    preparedFields = preparedFields.reduce((acc, i) => {
      acc[i.id] = i;
      if (i.newId) {
        acc[i.newId] = i;
      }

      return acc;
    }, {});
  }

  try {
    const parser = new Parser(formula, preparedFields, varAttr);
    parser.toJs();
  } catch (e) {
    const { args, translatingId } = e;
    let text = e.message;
    if (args && translatingId) {
      text = `${t(`modals.formulaErrors.${translatingId}`, args)}`;
    }
    const error = getValidateError(field, 'formulaConfig.formula', text);
    errors.push(error);
  }

  return errors;
};

export const validateFormulaParams = (field, allFields) => {
  const immutField = getImmutableField(field);

  const formulaType = immutField.get('formulaType');

  if (formulaType !== FORMULA_TYPES.FORMULA) {
    return [];
  }

  const errors = [];

  if (!formulaType) {
    const error = getValidateError(immutField, 'formulaConfig', 'field with formula should be with formula type');
    errors.push(error);
  }

  const requiredParams = FORMULA_REQUIRED_CONFIG_PARAMS[formulaType];
  if (!requiredParams) {
    errors.push(getValidateError(immutField, 'formulaConfig', `unknown formulaType: ${formulaType}`));
    return errors;
  }

  requiredParams.forEach((param) => {
    if (!immutField.getIn(['formulaConfig', param])) {
      const error = getValidateError(
        immutField,
        `formulaConfig.${param}`,
        t('modals.formulaErrors.requiredParamsError', [t(`modals.errorTypes.formulaConfig.${param}`)]),
      );
      errors.push(error); // добавил push(error)
    }
  });

  if (errors.length > 0) {
    return errors;
  }

  let formulaErrors = [];

  // Только для formula: парсим выражение
  if (formulaType === 'formula') {
    const formula = immutField.getIn(['formulaConfig', 'formula']);
    formulaErrors = validateFormula(formula, immutField, allFields.toJS());
    if (formulaErrors && formulaErrors.length > 0) {
      errors.push(...formulaErrors);
    }
  }

  return errors.concat(formulaErrors);
};
